import React, { useState } from 'react';
// material
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Hidden, Grid } from '@material-ui/core';

const CampaignContactHeader: React.FC<{}> = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <Grid container>
        <Grid item xs={5} sm={3} md={3} className={classes.col}>Name</Grid>
        <Grid item xs={4} sm={2} md={2} className={classes.col}>Phone/Email</Grid>
        <Hidden only={['xs']}>
          <Grid item xs={2} sm={2} md={2} className={classes.col}>City</Grid>
        </Hidden>
        <Hidden only={['xs']}>
          <Grid item xs={2} sm={1} md={1} className={classes.col}>Status</Grid>
        </Hidden>
        <Hidden only={['xs']}>
          <Grid item xs={2} sm={2} md={2} className={classes.col}>Link</Grid>
        </Hidden>
        <Grid item xs={2} sm={2} md={2} />
      </Grid>
    </div>
  );

}

export default CampaignContactHeader;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      padding: '0px 24px',
      marginBottom: 10
    },
    col: {
      fontWeight: 'bold'
    },
  })
);


// WEBPACK FOOTER //
// ./src/pages/campaign/components/CampaignContactHeader.tsx